import React, { useState, useEffect, useCallback } from 'react';
import { InputText, ImageUpload, DropdownField, PrimeCalendar } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import ImageGallery from 'components/admin/common/ImageGallery';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';
import { typeOptionProduct, formatDisplay, colorSelect } from 'core/constant/SELECT_OPTIONS';

const EditProductOptionModal = ({ show, productOption, handleClose, handleSave, updating, errors, deleteMediaItem, requestError, initialImages, productOptions }) => {
  const [formValues, setFormValues] = useState([]);
  const [galleryImages, setGalleryImages] = useState(initialImages);
  const { handleChange, handleFileChangeLocal, handleRemoveImageLocal } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(productOption);
    setGalleryImages(initialImages);
  }, [productOption, initialImages]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: productOption?.id }, galleryImages);
  }, [formValues, productOption?.id, handleSave, galleryImages]);

  return (
    <BaseModalForm show={show} title={productOption?.id ? "Editar Opción de Producto" : "Crear Opción de Producto"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <DropdownField
            label="Producto"
            value={formValues?.product_id}
            options={productOptions}
            onChange={(e) => handleChange('product_id', e.value)}
            placeholder="Seleccione el producto"
            error={errors?.product_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
            label="Formato"
            value={formValues?.display_type}
            options={formatDisplay}
            onChange={(e) => handleChange('display_type', e.value)}
            placeholder="Seleccione el formato"
            error={errors?.display_type}
          />
        </div>
        {formValues?.display_type === 'color' && (
          <div className="col-md-6 form-group">
            <DropdownField
              label="Color"
              value={formValues?.value}
              options={colorSelect}
              onChange={(e) => handleChange('value', e.value)}
              placeholder="Seleccione el color"
              error={errors?.value}
            />
          </div>
        )}
        {formValues?.display_type === 'text' && (
          <div className="col-md-6 form-group">
            <InputText
              label="Tamaño"
              value={formValues?.value}
              onChange={(e) => handleChange('value', e.target.value)}
              placeholder="Ingrese el tamaño"
              error={errors?.value}
            />
          </div>
        )}
        {formValues?.display_type !== 'text' && (
          <div className="col-md-6 form-group">
            <ImageUpload
              label="Imagen de la Opción de Producto"
              value={formValues?.url}
              onFileChange={(e) => handleFileChangeLocal(e, 'url')}
              onRemoveImage={() => handleRemoveImageLocal('url')}
              error={errors.url}
            />
          </div>
        )}
        {formValues?.display_type === 'image' && (
          <div className="col-md-6 form-group">
            <InputText
              label="Texto de CEO para la imagen"
              value={formValues?.value}
              onChange={(e) => handleChange('value', e.target.value)}
              placeholder="Ingrese el texto de optimización"
              error={errors?.value}
            />
          </div>
        )}
        <div className="col-md-6 form-group">
          <DropdownField
            label="Tipo"
            value={formValues?.type}
            options={typeOptionProduct}
            onChange={(e) => handleChange('type', e.value)}
            placeholder="Seleccione el tipo"
            error={errors?.type}
          />
        </div>
        <div className="col-12 form-group">
          <h4>Galería de Imágenes de los Producto Aplicados</h4>
          <ImageGallery initialImages={galleryImages} onImagesChange={setGalleryImages} onDeleteImage={deleteMediaItem} />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.PRODUCT_OPTIONS}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditProductOptionModal);
